// extracted by mini-css-extract-plugin
export var carouselContainer = "Carousel-module--carouselContainer--1mcgj";
export var carousel = "Carousel-module--carousel--F2UIT";
export var withBoxShadow = "Carousel-module--withBoxShadow--2Imly";
export var withCircleCorners = "Carousel-module--withCircleCorners--3jQxP";
export var ch2 = "Carousel-module--ch2--3oHx-";
export var ch2Container = "Carousel-module--ch2-container--2QX78";